import { render, staticRenderFns } from "./ProfileCustomer.vue?vue&type=template&id=c8a96c30"
import script from "./ProfileCustomer.vue?vue&type=script&lang=js"
export * from "./ProfileCustomer.vue?vue&type=script&lang=js"
import style0 from "./ProfileCustomer.vue?vue&type=style&index=0&id=c8a96c30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports